import React from "react";

export default ({ body }) => (
  <main id="racing-body" role="main">
    {body}
  </main>
);
